import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Globe } from 'lucide-react';

const languages = [
  { code: 'en', label: 'English', flag: 'EN' },
  { code: 'es', label: 'Espa\u00f1ol', flag: 'ES' },
];

const LanguageSwitcher = ({ variant = 'compact' }) => {
  const { i18n } = useTranslation();

  const handleChange = (value) => {
    i18n.changeLanguage(value);
    localStorage.setItem('slotfleet_language', value);
  };

  const currentLang = i18n.language?.split('-')[0] || 'en';

  if (variant === 'compact') {
    return (
      <Select value={currentLang} onValueChange={handleChange}>
        <SelectTrigger className="w-auto h-8 px-2 text-xs border-0 bg-transparent shadow-none ring-0 focus:ring-0 gap-1" data-testid="language-switcher">
          <Globe className="w-4 h-4 text-gray-400" />
          <span className="text-gray-400 font-medium">{currentLang.toUpperCase()}</span>
        </SelectTrigger>
        <SelectContent>
          {languages.map(lang => (
            <SelectItem key={lang.code} value={lang.code}>
              {lang.flag} {lang.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <Select value={i18n.language?.split('-')[0] || 'en'} onValueChange={handleChange}>
      <SelectTrigger className="w-[140px] h-9 border-border text-white" data-testid="language-switcher">
        <Globe className="w-4 h-4 mr-2" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {languages.map(lang => (
          <SelectItem key={lang.code} value={lang.code}>
            {lang.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitcher;
